import React from 'react';

import { Link, Typography, Stack, Box } from '@gogame/components';

const Breadcrumb = ({ path, dimensionName, drillEntityName, onChange }) => {
  const handleClickLink = (e) => {
    onChange(e, [...path]);
  };

  const label = (
    <Typography variant={'body1'} noWrap>
      {drillEntityName}
    </Typography>
  );

  return (
    <Stack
      align={'flex-start'}
      justifyContent={'center'}
      sx={{ minHeight: 38, maxWidth: 350 }}
    >
      <Typography variant={'caption'} noWrap>
        {dimensionName}
      </Typography>

      <Box color={'text.primary'}>
        {onChange ? <Link onClick={handleClickLink}>{label}</Link> : label}
      </Box>
    </Stack>
  );
};

export default Breadcrumb;
